import _ from "lodash";

const arePropsEqual = (prevProps, nextProps) => {
  if (_.isEqual(prevProps, nextProps)) {
    return true;
  } else {
    return false;
  }
};

export default arePropsEqual;
